import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_CREATE_VENDOR_ARTICLE,
    FAILURE_CREATE_VENDOR_ARTICLE_PRICE,
    FAILURE_DELETE_VENDOR_ARTICLE,
    FAILURE_DELETE_VENDOR_ARTICLE_PRICE,
    FAILURE_UPDATE_VENDOR_ARTICLE,
    FAILURE_UPDATE_VENDOR_ARTICLE_PRICE,
    FAILURE_VENDOR_ARTICLES,
    FAILURE_VENDOR_ARTICLE_PRICES,
    REQUEST_CREATE_VENDOR_ARTICLE,
    REQUEST_CREATE_VENDOR_ARTICLE_PRICE,
    REQUEST_DELETE_VENDOR_ARTICLE,
    REQUEST_DELETE_VENDOR_ARTICLE_PRICE,
    REQUEST_UPDATE_VENDOR_ARTICLE,
    REQUEST_UPDATE_VENDOR_ARTICLE_PRICE,
    REQUEST_VENDOR_ARTICLES,
    REQUEST_VENDOR_ARTICLE_PRICES,
    SUCCESS_CREATE_VENDOR_ARTICLE,
    SUCCESS_CREATE_VENDOR_ARTICLE_PRICE,
    SUCCESS_DELETE_VENDOR_ARTICLE,
    SUCCESS_DELETE_VENDOR_ARTICLE_PRICE,
    SUCCESS_UPDATE_VENDOR_ARTICLE,
    SUCCESS_UPDATE_VENDOR_ARTICLE_PRICE,
    SUCCESS_VENDOR_ARTICLES,
    SUCCESS_VENDOR_ARTICLE_PRICES,
} from './actions';

export function vendorArticlesReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_VENDOR_ARTICLES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VENDOR_ARTICLES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_VENDOR_ARTICLES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_VENDOR_ARTICLE:
        case REQUEST_UPDATE_VENDOR_ARTICLE:
        case REQUEST_DELETE_VENDOR_ARTICLE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_VENDOR_ARTICLE:
        case SUCCESS_UPDATE_VENDOR_ARTICLE:
        case SUCCESS_DELETE_VENDOR_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_CREATE_VENDOR_ARTICLE:
        case FAILURE_UPDATE_VENDOR_ARTICLE:
        case FAILURE_DELETE_VENDOR_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function vendorArticlePricesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VENDOR_ARTICLE_PRICES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VENDOR_ARTICLE_PRICES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_VENDOR_ARTICLE_PRICES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_VENDOR_ARTICLE_PRICE:
        case REQUEST_UPDATE_VENDOR_ARTICLE_PRICE:
        case REQUEST_DELETE_VENDOR_ARTICLE_PRICE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_VENDOR_ARTICLE_PRICE:
        case SUCCESS_UPDATE_VENDOR_ARTICLE_PRICE:
        case SUCCESS_DELETE_VENDOR_ARTICLE_PRICE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_CREATE_VENDOR_ARTICLE_PRICE:
        case FAILURE_UPDATE_VENDOR_ARTICLE_PRICE:
        case FAILURE_DELETE_VENDOR_ARTICLE_PRICE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
